package navigation.home.proposal

import navigation.home.proposal.addeditproposal.AddEditProposalScreenModel
import navigation.home.proposal.allproposal.AllProposalScreenModel
import navigation.home.proposal.proposal.ProposalOverviewScreenModel
import navigation.home.proposal.selectservice.SelectServiceScreenModel
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val proposalUiModule
    get() =
        module {
            factoryOf(::AllProposalScreenModel)
            factory { parameters ->
                // Todo: Pass this from ui using events
                val proposalId = parameters.get<Pair<String, String?>>(0).second
                AddEditProposalScreenModel(
                    proposalRepository = get(),
                    priceRepository = get(),
                    taskRepository = get(),
                    areaRepository = get(),
                    categoryRepository = get(),
                    fileRepository = get(),
                    paymentLinkRepository = get(),
                    clientRepository = get(),
                    stripeClient = get(),
                    updateProposalServiceUseCase = get(),
                    toastManager = get(),
                    proposalId = proposalId,
                    getCurrentUserUseCase = get(),
                    loadingManager = get(),
                    profileRepository = get(),
                    travelAgentRepository = get(),
                    addTaskUseCase = get(),
                    updateTaskUseCase = get(),
                    deleteTaskUseCase = get(),
                )
            }
            factoryOf(::ProposalOverviewScreenModel)
            factoryOf(::SelectServiceScreenModel)
        }